import { LegalLayout } from "../components/LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout
      overline="Informativa"
      title={<>Cookie <span className="italic text-[#D47738]">Policy</span></>}
      updated="Giugno 2026"
      related={[
        { to: "/privacy", label: "Privacy Policy" },
        { to: "/gdpr", label: "Diritti GDPR" },
      ]}
      sections={[
        {
          h: "Cosa sono i cookie",
          p: [
            "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Servono a far funzionare il sito e a migliorarne l'esperienza d'uso.",
          ],
        },
        {
          h: "Tipologie di cookie utilizzati",
          p: ["Questo sito utilizza le seguenti categorie di cookie:"],
          list: [
            "Cookie tecnici necessari: indispensabili per il funzionamento del sito, del carrello e della procedura di pagamento. Non richiedono consenso.",
            "Cookie di preferenza: memorizzano scelte come la verifica dell'età e il consenso ai cookie.",
            "Cookie statistici: raccolgono informazioni aggregate e anonime sull'utilizzo del sito, installati solo previo consenso.",
          ],
        },
        {
          h: "Cookie di terze parti",
          p: [
            "Durante la fase di pagamento, il fornitore Stripe può installare cookie tecnici necessari alla sicurezza della transazione e alla prevenzione delle frodi.",
          ],
        },
        {
          h: "Gestione del consenso",
          p: [
            "Alla prima visita ti viene mostrato un banner con cui puoi accettare o rifiutare i cookie non necessari. Puoi modificare in ogni momento le tue preferenze cancellando i cookie dal tuo browser.",
          ],
        },
        {
          h: "Come disabilitare i cookie",
          p: [
            "Puoi gestire o disabilitare i cookie direttamente dalle impostazioni del tuo browser (Chrome, Firefox, Safari, Edge). La disabilitazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito, come il carrello.",
          ],
        },
      ]}
    />
  );
}
